import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HUB_API_SETTINGS_TOKEN } from '../../hub-api-settings-token';
import { HubApiSettingsService } from '../../hub-api-settings.service';
import { Query } from '../model/query/query';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Generated service for communicating with the WebQuery API endpoint.
@Injectable()
export class WebQueryEndpointService {

  constructor(
    private http: HttpClient,
    private settingsService: HubApiSettingsService,
  ) {}

  Get(query: Query): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
      body: query,
    };

    return this.http.request(
      'POST',
      this.settingsService.getApiServiceBaseUrl() + 'webQuery',
      options);
  }
}
